import { useCrypto } from "./useCrypto"
import { post } from "./useRequest"
import { useUtils } from "./useUtils"
import enData from "@/langurage/en"
import zhData from "@/langurage/zh"

function t(key = '') {
    const cLanguage = localStorage.getItem("lang") || "zh"
    if (cLanguage == 'zh') {
        return zhData[key] || key
    } else {
        return enData[key] || key
    }

}

const { suc_msg, err_msg } = useUtils()
const crypto = useCrypto()
/*
     html---

        <span
            class="valid"
            :class="{unValid: code_object.isCodeStart}"
            @click.stop="code_object.getCodeApiHandleFn(13111111111)"
        >{{ code_object.isCodeStart ? code_object.codePlac || '' : $t('获取验证码') }}</span>

    js---
        const code_object = ref(useCode());
        code_object.value.codeType = 5;

        // 关闭倒计时
        code_object.value.closeFn()
*/
/** 获取验证码 */
export const useCode = () => {
    const DEFAULT_TIME = 60;
    return {
        handlerTimer: DEFAULT_TIME,
        downTimer: -1,
        codePlac: t('获取验证码'),
        isCodeStart: false,
        getCodeLoading: false,
        codeType: 1,
        accountType: 1, // 1 phone 2 email
        mobile: '',
        isRealObject: true,
        user_id: '',
        /** 验证表单信息 */
        verifyFn() {
            let msgDesc = '';
            if (this.accountType == 1) {
                if (!this.mobile) msgDesc = t('请输入手机号')
                else if (!this.authedticationMobile(this.mobile)) msgDesc = t('手机号输入错误请重新输入')
            } else {
                if (!this.mobile) msgDesc = t('请输入邮箱')
                else if (!this.authenEmail(this.mobile)) msgDesc = t('邮箱输入错误请重新输入')
            }

            msgDesc && err_msg(msgDesc);
            return !msgDesc;
        },
        /** 是否为有效的手机号 */
        authedticationMobile(mobile = '') { return /^1[3-9]\d{9}$/.test(mobile) },
        /** 认证是否为有效邮箱 */
        authenEmail(email = '') { return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email); },
        /** 开始倒计时 */
        startHandlerDownTimeFn() {
            if (this.isCodeStart) return;
            this.isCodeStart = true;
            this.codePlac = `${this.handlerTimer}${t("重新获取")}`;
            this.downTimer = setInterval(() => {
                this.handlerTimer--;
                if (this.handlerTimer < 0) {
                    clearInterval(this.downTimer)
                    this.handlerTimer = DEFAULT_TIME;
                    this.isCodeStart = false;
                    this.codePlac = t('获取验证码');
                } else {
                    this.codePlac = `${this.handlerTimer}${t('重新获取')}`;
                }
            }, 1000);
        },
        /**
         * 发送验证码
         * @param {String} mobile 手机号（不传使用创建对象时输入的手机号）
         */
        async getCodeApiHandleFn(mobile = '', type = 'phone') {
            this.accountType = "phone" == type ? 1 : 2;
            /* if (this.authedticationMobile(mobile))  */
            this.mobile = mobile;
            if (this.isCodeStart || this.getCodeLoading || !this.verifyFn()) return;
            this.getCodeLoading = true;
            try {
                // 获取防刷code
                /*  const captcha_data = crypto.getCaptchaData()
                 const res1: any = await post("6668f5d1d434e", { method: "POST", body: { captcha_data } })
                 const captcha_key = res1.captcha_key;
                 const account_type = "mobile"
                 const res: any = await post("666a45d4d6bb4", { */

                const captcha_data = "";
                const captcha_key = "";
                const res: any = await post("5b5bdc44796e8", {
                    account: this.mobile,
                    account_type: this.accountType,
                    type: this.codeType,
                    captcha_data,
                    captcha_key,
                    is_test: 1,
                });
                this.startHandlerDownTimeFn();
                suc_msg(res.data.code ? res.data.code : t("验证码发送成功"))
            } catch (error: any) { err_msg(error?.msg || t("失败")); }
            this.getCodeLoading = false;
        },
        /** 关闭倒计时 */
        closeFn() {
            clearInterval(this.downTimer);
            this.handlerTimer = DEFAULT_TIME;
            this.codePlac = t('获取验证码');
            this.isCodeStart = false;
            this.getCodeLoading = false;
        },
    };
}